import React from "react";
import styled from "styled-components";

const Addresses = () => (
  <AddressesWrapper>
    <div>
      <Header>Dystrybutor - Ozparts</Header>
      <p>
      OZPARTS PL sp. z o.o.
        <br />
        NIP 9562230129
        <br />
        Słowackiego 32/5
        <br />
        87-100 Toruń, Polska
      </p>
    </div>
    <div>
      <Header>Pedders EU – magazyn</Header>
      <p>
        Mazowiecka 46-48
        <br />
        87-100 Toruń, Polska
        <br />
        support@pedders.pl
        <br /> www.pedders.pl
      </p>
    </div>
  </AddressesWrapper>
);

export default Addresses;

const AddressesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
`;

const Header = styled.p`
  font-weight: 700;
  font-size: 14px;
`;
